import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum GameType {
  FishingStar = 'FishingStar', // 捕鱼游戏
  MermaidLegend = 'MermaidLegend', // 灵仙捕鱼
}

// 获取FishingStar游戏链接 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164398914
export const get_fish_star_info = createAsyncThunk(
  'get_fish_star_info',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/ground/get_fish_star_info',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_third_party_game = createAsyncThunk(
  'get_third_party_game',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/ground/get_third_party_game',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export enum ThirdGameStatus {
  Offline = 2,
}

interface InitialStateType {
  status?: number
  game_id?: number
  name?: string
  download_url?: string
  err_msg?: string
  game_url?: string
}

const initialState: InitialStateType = {}

export const ThridMidPageSlice = createSlice({
  name: 'ThridMidPage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 主页
    builder.addCase(get_fish_star_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
      })
    })
    builder.addCase(get_third_party_game.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
      })
    })
  },
})

export default ThridMidPageSlice.reducer
export const TeenPattiActions = ThridMidPageSlice.actions
export const useThridMidPage = () => {
  return useSelector((state) => state.Animal_Badger)
}
